import React from 'react';
import weighingService from '@/services/weighing';

interface TransferStickerSectionProps {
  formData: {
    numeroTransfert: string;
    sticker: string;
  };
  onInputChange: (field: string, value: any) => void;
  className?: string;
}

const TransferStickerSection: React.FC<TransferStickerSectionProps> = ({
  formData,
  onInputChange,
  className = ''
}) => {
  // Gestionnaire pour l'upload de fichier
  const handleFileUpload = async (file: File) => {
    try {
      const uploadFormData = new FormData();
      uploadFormData.append('fichier', file);
      uploadFormData.append('numero', formData.numeroTransfert || 'FICHE_' + Date.now());
      uploadFormData.append('type_fichier', file.type.split('/')[1]);
      uploadFormData.append('description', `Fiche uploadée pour ${formData.numeroTransfert}`);

      const response = await weighingService.createFiche(uploadFormData);
      console.log('Fiche uploadée avec succès:', response);
      // Ici vous pouvez mettre à jour le formulaire avec l'ID de la fiche
      if (response && response.data) {
        onInputChange('fiche', response.data.id);
      }
    } catch (error) {
      console.error('Erreur lors de l\'upload de la fiche:', error);
    }
  };

  return (
    <div className={`space-y-3 ${className}`}>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          <i className="fas fa-file-export text-blue-500 mr-2"></i>
          Numéro de Transfert
        </label>
        <div className="flex items-center space-x-2">
          <input
            type="text"
            value={formData.numeroTransfert}
            onChange={(e) => onInputChange('numeroTransfert', e.target.value)}
            className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Ex: TRF-2024-001"
          />
          <button 
            onClick={() => document.getElementById('ficheInput')?.click()}
            className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm flex items-center space-x-2"
            title="Attacher une fiche de transfert"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
            </svg>
            <span>Fiche</span>
          </button>
          <input
            id="ficheInput"
            type="file"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) {
                handleFileUpload(file);
              }
            }}
            className="hidden"
          />
        </div>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          <i className="fas fa-tag text-green-500 mr-2"></i>
          Numéro de Sticker
        </label>
        <input
          type="text"
          value={formData.sticker}
          onChange={(e) => onInputChange('sticker', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          placeholder="Ex: STK-2024-001"
        />
      </div>
    </div>
  );
};

export default TransferStickerSection;
